
// 연동 서버
// SNMP 설정 - SNMP 사용자
//
// @since 2018-08-24

export const state = () => ({
  url: '/api/sm/external/snmp/users', // SNMP 사용자 조회/수정 URL
  urlUse: '/api/sm/external/snmp/use', // SNMP 사용여부
  urlV3Edit: '/api/sm/external/snmp/v3', // PUT SNMP v3설정 사용여부 수정
  urlCommit: '/api/sm/external/snmp', // SNMP 사용자 적용/취소 URL
  urlTrap: '/api/sm/external/snmp/snmptrap', // SNMP Trap
  snmpUserList: [], // 조회 데이터
  snmpUserListOrigin: [], // 조회 원본 데이터
  snmpTrapList: [], // trap 조회 데이터
  snmpTrapListOrigin: [], // trap 조회 원본 데이터
  snmpUserData: { // 편집중인 데어터
    // snmp_usr_id: 0, //  SNMP 사용자의 고유 ID
    // svr_name: '', //    required (string) 사용자 서버 이름
    // usr_name: '', //    required (string) 사용자 이름
    // security: 0, //     required (one of 0, 1, 2 - default: 0) 사용자 보안 인증 없음: 0, 사용자 인증: 1, 사용자 인증 메시지 암호화: 2
    // auth_type: 0, //    required (one of 0, 1 - default: 0) 사용자 인증 타입 SHA-1: 0, MD5: 1
    // msg_enc_type: 0, // required (one of 0, 1 - default: 0) 메시지 암호화 타입 AES: 0, DES: 1
    // auth_pw: '', //     required (string) 사용자 인증에서 사용하기 위한 비밀번호
    // msg_enc_pw: '' //   required (string) 메시지 인증에서 사용하기 위한 비밀번호
    snmp_community_name: '',
    snmp_enable_yn: 0,
    snmp_user_auth_type: 0,
    snmp_user_enc_type: 0,
    snmp_user_id: 1,
    snmp_user_name: '',
    snmp_user_server_uname: '',
    snmp_user_type: 0,
    // snmp_user_v3_use_yn: 0,
    snmp_user_auth_pw: '',
    snmp_user_enc_pw: ''
  },
  errorMsg: ''
})

export const mutations = {
  // SNMP 사용자 조회
  getSnmpUserList: (state, item) => {
    state.snmpUserList = item
    state.snmpUserListOrigin = _.cloneDeep(item)
  },
  // 사용 전체 사용/사용 안 함 적용.
  changeAllUseYn (state, data) {
    const useData = _.cloneDeep(state.snmpUserList)
    _.forEach(useData, o => {
      o.snmp_user_v3_use_yn = data
    })
    state.snmpUserList = useData
  },
  // SNMP 사용자 추가
  addSnmpUser: () => {
  },
  // SNMP 사용자 편집
  edtSnmpUser: () => {
  },
  getSnmpUse: (state, item) => {
    state.snmpUserData.snmp_enable_yn = item.snmp_enable_yn
    state.snmpUserData.snmp_community_name = item.snmp_community_name
  },
  // SNMP 사용자 삭제
  delSnmpUser: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.snmpUserList, {snmp_user_id: itemKey.snmp_user_id})
      if (idx >= 0) {
        state.snmpUserList.splice(idx, 1)
      }
    }
  },
  setErrorMsg: (state, data) => {
    state.errorMsg = data.msg
  },
  clearSnmpUserData: (state) => {
    state.snmpUserData = {
      snmp_community_name: '',
      // snmp_enable_yn: 0,
      snmp_user_auth_type: 0,
      snmp_user_enc_type: 0,
      snmp_user_id: 1,
      snmp_user_name: '',
      snmp_user_server_uname: '',
      snmp_user_type: 0,
      snmp_user_auth_pw: '',
      snmp_user_enc_pw: ''
    }
  },
  // SNMP Trap 조회
  setSnmpTrapList: (state, item) => {
    state.snmpTrapList = item
    state.snmpTrapListOrigin = _.cloneDeep(item)
  }
}

export const actions = {
  async getSnmpUserList ({commit, state}) {
    const notUseLoadingParam = {
      loadingShow: true,
      loadingHide: true
    }
    try {
      const {code, result} = await this.$axios.$get(`${state.url}/0`, notUseLoadingParam)
      if (code === 'ok') {
        commit('getSnmpUserList', result)
        return true
      } else {
        commit('setErrorMsg', result)
      }
      return false
    } catch (e) {
      return false
    }
  },
  async addSnmpUser ({commit, state}, data) {
    const payload = _.cloneDeep(data)
    delete payload.snmp_user_id
    delete payload.snmp_enable_yn
    delete payload.snmp_community_name
    if (payload.snmp_user_auth_pw.length !== 0) {
      payload.snmp_user_auth_pw = btoa(payload.snmp_user_auth_pw)
    }
    if (payload.snmp_user_enc_pw.length !== 0) {
      payload.snmp_user_enc_pw = btoa(payload.snmp_user_enc_pw)
    }
    const {code, result} = await this.$axios.$post(state.url, payload)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      // commit('addSnmpUser', result)
      return true
    } else {
      commit('setErrorMsg', result)
    }
    return false
  },
  async edtSnmpUser ({commit, state}, data) {
    const payload = _.cloneDeep(data)
    if (payload.snmp_user_auth_pw.length !== 0) {
      payload.snmp_user_auth_pw = btoa(payload.snmp_user_auth_pw)
    }
    if (payload.snmp_user_enc_pw.length !== 0) {
      payload.snmp_user_enc_pw = btoa(payload.snmp_user_enc_pw)
    }
    const {code, result} = await this.$axios.$put(state.url, payload)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtSnmpUser', result)
      return true
    } else {
      commit('setErrorMsg', result)
    }
    return false
  },
  async getSnmpUse ({commit, state}) {
    const notUseLoadingParam = {
      loadingShow: true,
      loadingHide: true
    }
    const {code, result} = await this.$axios.$get(state.urlUse, notUseLoadingParam)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('getSnmpUse', result)
      return true
    } else {
      commit('setErrorMsg', result)
    }
    return false
  },
  async setSnmpUse ({commit, state}, data) {
    const {code, result} = await this.$axios.$post(state.urlUse, data, {successAlert: false})
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      commit('setErrorMsg', result)
    }
    return false
  },
  async edtSnmpUserList ({commit, state}, payload) {
    const {code, result} = await this.$axios.$put(state.urlV3Edit, payload, {successAlert: false})
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtSnmpUserList', result)
      return true
    } else {
      commit('setErrorMsg', result)
    }
    return false
  },
  async delSnmpUser ({commit, state}, param) {
    const data = await this.$axios.$delete(state.url, {data: param},
      {
        failAlert: false
      })
    if (data.code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      commit('setErrorMsg', data.result)
    }
    return false
  },
  // trap 리스트 조회
  async getSnmpTrapList ({commit, state}) {
    const notUseLoadingParam = {
      loadingShow: true,
      loadingHide: true
    }
    try {
      const {code, result} = await this.$axios.$get(`${state.urlTrap}/0`, notUseLoadingParam)
      if (code === 'ok') {
        commit('setSnmpTrapList', result)
        return true
      } else {
        commit('setErrorMsg', result)
      }
      return false
    } catch (e) {
      return false
    }
  },
  // trap 사용여부 수정
  async setSnmpTrapUse ({commit, state}, data) {
    const {code, result} = await this.$axios.$put(`${state.urlTrap}/use`, {items: data}, {loading: false, successAlert: false})
    if (code === 'ok') {
      return true
    } else {
      commit('setErrorMsg', result)
    }
    return false
  },
  // trap 수정
  async edtSnmpTrap ({commit, state}, data) {
    const payload = _.cloneDeep(data)
    if (payload.snmp_trap_userauth_pw !== '') {
      payload.snmp_trap_userauth_pw = btoa(payload.snmp_trap_userauth_pw)
    }
    if (payload.snmp_trap_msgenc_pw !== '') {
      payload.snmp_trap_msgenc_pw = btoa(payload.snmp_trap_msgenc_pw)
    }
    const {code, result} = await this.$axios.$put(`${state.urlTrap}/${payload.snmp_trap_id}`, payload, {successAlert: false})
    if (code === 'ok') {
      return true
    } else {
      commit('setErrorMsg', result)
    }
    return false
  },
  async finalCommand ({commit, state}, type) {
    let param = {}
    let paramData = {}
    if (type === 'apply') {
      param = { applyMsg: true }
      paramData = {
        snmp_community_name: state.snmpUserData.snmp_community_name,
        snmp_enable_yn: state.snmpUserData.snmp_enable_yn
      }
    } else {
      param = { cancelMsg: true }
      paramData = null
    }
    const {code, result} = await this.$axios.$put(`${state.urlCommit}/${type}`, paramData, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      commit('setErrorMsg', result)
    }
    return false
  }
}

export const getters = {
}

export const strict = false
